import {addDays, addHours, addMinutes, addSeconds} from 'date-fns'
import type {TISOTimestamp} from '@kapitalist/contract/types'
import {mkISOTimestamp} from '@kapitalist/contract/types'

export const daysAgo = (n: number, d: Date = new Date()): TISOTimestamp =>
  mkISOTimestamp(addDays(d, -1 * n).toISOString())

export const hrsAgo = (n: number, d: Date = new Date()): TISOTimestamp =>
  mkISOTimestamp(addHours(d, -1 * n).toISOString())

export const minsAgo = (n: number, d: Date = new Date()): TISOTimestamp =>
  mkISOTimestamp(addMinutes(d, -1 * n).toISOString())

export const secsAgo = (n: number, d: Date = new Date()): TISOTimestamp =>
  mkISOTimestamp(addSeconds(d, -1 * n).toISOString())

export const inDays = (n: number, d: Date = new Date()): TISOTimestamp =>
  mkISOTimestamp(addDays(d, n).toISOString())

export const inMinutes = (n: number, d: Date = new Date()): TISOTimestamp =>
  mkISOTimestamp(addMinutes(d, n).toISOString())
